import React from "react";
import Header from "../../components/Header/index";
import withAuth from "../../services/withAuth";
import MembersApi from "../../services/portal-api/MembersApi";
import SelectInput from "../../components/Form/components/SelectInput";
import Graph from "./graph";
import NavigationBar from "../Navigation";
import JobGraph from "./JobGraph";
import NotFound from "../NotFound";
import AuthService from "../../services/AuthService";

class Analytics extends React.Component {
    constructor(props) {
        super(props);
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        this.state = {
            givexValues: [],
            futuraValues: [],
            dotdigitalValues: [],
            customDate: false,
            jobCustomDate: false,
            newMemberJob: [],
            updateMemberJob: [],
            newMemberJobFailedOn: [],
            updateMemberJobFailedOn: [],
            data: {
                apiStatusRange: 5,
                customFrom: "",
                customTo: "",
                localDate: formattedDate,
                jobStatusRange: 5,
                jobCustomFrom: "",
                jobCustomTo: ""
            },
        };
    }

    componentDidMount() {
        document.title = "Analitics - DuskPortal";
        document.body.className = "";

        this.graphData();
        this.jobGraphData();

        const currentDate = new Date();

        // This week
        const today = currentDate.getDay();
        const firstDayOfWeek = new Date(currentDate);
        firstDayOfWeek.setDate(currentDate.getDate() - today);
        const lastDayOfWeek = new Date(currentDate);
        lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

        // Last week
        const firstDayOfLastWeek = new Date(firstDayOfWeek);
        firstDayOfLastWeek.setDate(firstDayOfWeek.getDate() - 7);
        const lastDayOfLastWeek = new Date(lastDayOfWeek);
        lastDayOfLastWeek.setDate(lastDayOfWeek.getDate() - 7);

        // This month
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

        // Last month
        const firstDayOfLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
        const lastDayOfLastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

        // Format the dates in day/month/year format
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${day}/${month}/${year}`;
        };

        const thisWeek = {
            startDate: formatDate(firstDayOfWeek),
            endDate: formatDate(lastDayOfWeek)
        };

        const lastWeek = {
            startDate: formatDate(firstDayOfLastWeek),
            endDate: formatDate(lastDayOfLastWeek)
        };

        const thisMonth = {
            startDate: formatDate(firstDayOfMonth),
            endDate: formatDate(lastDayOfMonth)
        };

        const lastMonth = {
            startDate: formatDate(firstDayOfLastMonth),
            endDate: formatDate(lastDayOfLastMonth)
        };

        console.log("This week:", thisWeek.startDate, "-", thisWeek.endDate);
        console.log("Last week:", lastWeek.startDate, "-", lastWeek.endDate);
        console.log("This month:", thisMonth.startDate, "-", thisMonth.endDate);
        console.log("Last month:", lastMonth.startDate, "-", lastMonth.endDate);
    }

    graphData = () => {
        MembersApi.apiStatsToGraph(this.state.data, (response) => {
            if (response.success) {
                this.setState({
                    givexValues: response.json.data.hasOwnProperty("Givex") ? response.json.data.Givex : [],
                    futuraValues: response.json.data.hasOwnProperty("Futura") ? response.json.data.Futura : [],
                    dotdigitalValues: response.json.data.hasOwnProperty("DotDigital") ? response.json.data.DotDigital : [],
                }, () => {
                    console.log("Success/Failed fetching API stats...");
                });
            }
        });
    };

    jobGraphData = () => {
        MembersApi.jobsToGraph(this.state.data, (response) => {
            if (response.success) {
                this.setState({
                    newMemberJob: response.json.data.hasOwnProperty("newMemberJob") ? response.json.data.newMemberJob : [],
                    updateMemberJob: response.json.data.hasOwnProperty("updateMemberJob") ? response.json.data.updateMemberJob : [],
                    newMemberJobFailedOn: response.json.data.hasOwnProperty("newMemberJobFailedOn") ? response.json.data.newMemberJobFailedOn : [],
                    updateMemberJobFailedOn: response.json.data.hasOwnProperty("updateMemberJobFailedOn") ? response.json.data.updateMemberJobFailedOn : [],
                }, () => {
                    console.log("Success/Failed fetching API stats...");
                });
            }
        });
    };

    dropdpown = () => [
        {
            key: 5,
            value: "Last hour",
        },
        {
            key: 1,
            value: "Last 24 hours",
        },
        {
            key: 2,
            value: "Last 7 days",
        },
        {
            key: 3,
            value: "Last 30 days",
        },
        {
            key: 4,
            value: "Custom date range",
        },
    ];

    handleApiStatusRangeChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let data = this.state.data;
        data[name] = value;
        if (value != 4) {
            this.setState({
                data: data,
                customDate: false,
                customFrom: "",
                customTo: "",
            }, () => {
                console.log("Date range changed");
                this.graphData();
            });
        } else {
            this.setState({
                data: data,
                customDate: true,
                customFrom: "",
                customTo: "",
            }, () => {
                console.log(
                    "Custom date range enabled: ",
                    this.state.data.customFrom,
                    this.state.data.customTo
                );
                this.graphData();
            });
        }
    };

    handleCustomDateRange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let data = this.state.data;
        data[name] = value;
        this.setState({
            data: data,
            customDate: true,
        }, () => {
            console.log("Custom date range selected");
            this.graphData();
        });
    };

    handleJobStatusRangeChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let data = this.state.data;
        data[name] = value;
        if (value != 4) {
            this.setState({
                data: data,
                jobCustomDate: false,
                jobCustomFrom: "",
                jobCustomTo: ""
            }, () => {
                console.log("Date range changed");
                this.jobGraphData();
            });
        } else {
            this.setState({
                data: data,
                jobCustomDate: true,
                jobCustomFrom: "",
                jobCustomTo: ""
            }, () => {
                console.log("Custom date range enabled");
                this.jobGraphData();
            });
        }
    };

    handleJobCustomDateRange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let data = this.state.data;
        data[name] = value;
        this.setState({
            data: data,
            jobCustomDate: true,
        }, () => {
            console.log("Custom date range selected: ", data);
            this.jobGraphData();
        });
    };

    apiStatsFunction = (details) => {
        const param = {
            statusRange: details.endPoint == 'api' ? this.state.data.apiStatusRange : this.state.data.jobStatusRange,
            customFrom: details.endPoint == 'api' ? this.state.data.customFrom : this.state.data.jobCustomFrom,
            customTo: details.endPoint == 'api' ? this.state.data.customTo : this.state.data.jobCustomTo
        };
        const graphTime = this.fetchGraphTime(param);
        let toUrl = `/admin?sec=${details.endPoint}&type=${details.type}&column=${details.column}&token=${details.token}&graphTime=${graphTime}`;
        if(details.endPoint == 'job') {
            const localTime = new Date();
            let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            let offset = localTime.getTimezoneOffset();
            toUrl += `&offset_tz=${offset}&timezone=${tz}&offset=0`;
        }
        
        this.props.history.push(toUrl);
    };

    fetchGraphTime = (param) => {
        const date = new Date();
        let year = date.getFullYear();
        let month = String(date.getMonth() + 1).padStart(2, "0");
        let day = String(date.getDate()).padStart(2, "0");
        const currentDate = `${day}/${month}/${year}`;
        let graphTime;

        if (param.statusRange == 1) {
            if(day == 1) {
                month -= 1;
            }
            date.setDate(date.getDate() - 1);
            day = String(date.getDate()).padStart(2, "0");            
            graphTime = `${day}/${month}/${year} 00:00:00|${currentDate} 23:59:59`;
        } else if (param.statusRange == 2) {
            if(day < 7) {
                month -= 1;
            }
            date.setDate(date.getDate() - 7);
            day = String(date.getDate()).padStart(2, "0");
            graphTime = `${day}/${month}/${year} 00:00:00|${currentDate} 23:59:59`;
        } else if (param.statusRange == 3) {
            if (month == 1) {
                month = 12;
                year -= 1;
            } else {
                month -= 1;
            }
            date.setDate(date.getDate() - 30);
            day = String(date.getDate()).padStart(2, "0");
            graphTime = `${day}/${month}/${year} 00:00:00|${currentDate} 23:59:59`;
        } else if(param.statusRange == 5) {
            date.setHours(date.getHours() - 1);
            const lessThanAnHour = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
            graphTime = `${lessThanAnHour}|${currentDate} 23:59:59`;
        } else {
            graphTime = `${new Date(param.customFrom).toLocaleDateString("en-GB")} 00:00:00|${new Date(param.customTo).toLocaleDateString("en-GB")} 23:59:59`;
        }
        
        return graphTime;
    }

    render() {
        return (
            AuthService.can('analytics') ?
                <div>
                    <Header />
                    <main className="content" role="main">
                        <div className="container container--wide padding--40">
                            <div
                                className="info-wrap col gutter--40 margin--10--bot"
                                style={{ borderBottom: "1px solid #ccc" }}
                            >
                                <div className="col">
                                    <NavigationBar />
                                </div>
                            </div>
                            <h2 className="text--light text--color text--40" style={{ marginBottom: "20px" }}>
                                Analytics
                            </h2>
                            <div className="col-3 gutter--40">
                                <div className="col">
                                    <SelectInput
                                        name="jobStatusRange"
                                        label="Jobs"
                                        options={this.dropdpown()}
                                        value={this.state.data.jobStatusRange}
                                        onChange={this.handleJobStatusRangeChange}
                                    />
                                </div>
                                {this.state.jobCustomDate && (
                                    <React.Fragment>
                                        <div className="col">
                                            <span className="sub-title text--grey">
                                                From
                                            </span>
                                            <input
                                                type="date"
                                                name="jobCustomFrom"
                                                value={this.state.data.jobCustomFrom}
                                                onChange={this.handleJobCustomDateRange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="col">
                                            <span className="sub-title text--grey">
                                                To
                                            </span>
                                            <input
                                                type="date"
                                                name="jobCustomTo"
                                                value={this.state.data.jobCustomTo}
                                                onChange={this.handleJobCustomDateRange}
                                                required={true}
                                            />
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                            <JobGraph 
                                newMemberJob={this.state.newMemberJob}
                                updateMemberJob={this.state.updateMemberJob}
                                newMemberJobFailedOn={this.state.newMemberJobFailedOn}
                                updateMemberJobFailedOn={this.state.updateMemberJobFailedOn}
                                apiStatsFunction={this.apiStatsFunction}
                            />

                            <div className="col-3 gutter--40">
                                <div className="col">
                                    <SelectInput
                                        name="apiStatusRange"
                                        label="API Logs"
                                        options={this.dropdpown()}
                                        value={this.state.data.apiStatusRange}
                                        onChange={this.handleApiStatusRangeChange}
                                    />
                                </div>
                                {this.state.customDate && (
                                    <React.Fragment>
                                        <div className="col">
                                            <span className="sub-title text--grey">
                                                From
                                            </span>
                                            <input
                                                type="date"
                                                name="customFrom"
                                                value={this.state.data.customFrom}
                                                onChange={this.handleCustomDateRange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="col">
                                            <span className="sub-title text--grey">
                                                To
                                            </span>
                                            <input
                                                type="date"
                                                name="customTo"
                                                value={this.state.data.customTo}
                                                onChange={this.handleCustomDateRange}
                                                required={true}
                                            />
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                            <Graph
                                givex={this.state.givexValues}
                                futura={this.state.futuraValues}
                                dotdigital={this.state.dotdigitalValues}
                                apiStatsFunction={this.apiStatsFunction}
                            />
                        </div>
                    </main>
                </div>
            :
                <NotFound forbidden={true} />
        );
    }
}

export default withAuth(Analytics);
